import * as React from "react";
import { useParams } from 'react-router-dom';
import { useGetOne, useRedirect, Title, Loading, useRecordContext } from 'react-admin';
import { Card, Stack, Typography } from '@mui/material';
import { Show, SimpleShowLayout, TextField, DateField, RichTextField } from 'react-admin';
import {StyledShow} from "../../themes/checkbrand-default/StyledComponents";

const StatusField = ({ source }: any) => {
    const record = useRecordContext();
    return (<span style={{ background: record[source] == 1 ? '#158315' : '#df1b1b', width: '10px', height: '10px', borderRadius: '50%', float: 'left'  }}>&nbsp;</span>);
};

export const KeywordShow = () => {
    const { id } = useParams();
    const redirect = useRedirect();
    const { data, isLoading } = useGetOne(
        'keywords',
        { id },
        { onError: () => redirect('/error') }
    );
    if (isLoading) { return <Loading />; }
    return (

        <StyledShow>
            <SimpleShowLayout>
                    <TextField source="keyword" />
                    <StatusField source="status" />
                    <TextField source="created_at" />
            </SimpleShowLayout>
        </StyledShow>
    
    );
};